import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import { Grid, IconButton, Paper, Stack } from '@mui/material'
import FormInput from 'components/FormInput'
import React, { useEffect } from 'react'
import { UseFieldArrayRemove, useFormContext } from 'react-hook-form'
import { phoneMask } from 'utils/mask.util'
import { SocioeducationMeasureIdentificationType } from 'types/socioeducation-measure-identification.type'

type PhoneItemProps = {
  index: number
  onRemove: UseFieldArrayRemove
  readonly?: boolean
  disabled?: boolean
}

export const PhoneItem: React.FC<PhoneItemProps> = ({ index, onRemove, readonly, disabled }) => {
  const { control, watch, setValue } = useFormContext<SocioeducationMeasureIdentificationType>()

  const phoneNumberValue = watch(`pessoaFisica.telefones.${index}.telefone`)

  useEffect(() => {
    setValue(`pessoaFisica.telefones.${index}.telefone`, phoneMask(phoneNumberValue))
  }, [setValue, index, phoneNumberValue])

  return (
    <Paper variant='outlined' sx={{ p: 3, width: '100%', backgroundColor: 'white' }}>
      <Grid container spacing={2}>
        <Grid item md={3} xs={12}>
          <FormInput
            control={control}
            name={`pessoaFisica.telefones.${index}.telefone`}
            label='Telefone'
            placeholder='Informe o telefone'
            maxLength={15}
            readonly={readonly}
            disabled={disabled}
          />
        </Grid>
        <Grid item md={9} xs={12}>
          <Stack spacing={1} direction='row'>
            <FormInput
              control={control}
              name={`pessoaFisica.telefones.${index}.descricao`}
              label='Descrição'
              maxLength={20}
              placeholder='Informe a descrição'
              readonly={readonly}
              disabled={disabled}
            />
            {index >= 1 && (
              <IconButton onClick={() => onRemove(index)} disabled={disabled}>
                <DeleteOutlineRoundedIcon color='error' />
              </IconButton>
            )}
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  )
}
